<div class="listing-container"
     [class.overflow-auto-and-scroll]="true"
     [class.listing-container-vs-toolbar]="false"
     [class.listing-container-static]="application.state=='static_article'">
  <div class="article-view"
       [class.center75]="application.state!='static_article'"
       [class.center65]="application.state=='static_article'">
    <mat-card class="left-card" *ngIf="!this.articleData">
      <div class="internal-spinner">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
    </mat-card>
    <mat-card class="left-card" *ngIf="this.articleData && this.articleData['article']">
      <div class="item-date"><span i18n>Updated</span>: {{(this.listItem['itemFullData']['local_mdate']*1000) | fsDate}}</div>
      <div *ngFor="let article of this.articleData['article']; let i = index" class="item-wrapper"
           [class.item-first]="i === 0"
           [class.item-edit]="articleMode === 'edit'">
        <!--title,text,image,cta-->
        <!--<h1>{{article['type']}} {{index}}</h1>-->

        <!--EDIT Controls-->
        <div class="block-edit-container" *ngIf="articleMode === 'edit'">
          <button mat-icon-button class="article-action-btn" (click)="editItem($event,i)">
            <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Edit'">edit</mat-icon>
          </button>
          <button mat-icon-button class="article-action-btn" (click)="addItem($event,i)">
            <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'New item below'">add_circle_outline
            </mat-icon>
          </button>
          <button mat-icon-button class="article-action-btn" (click)="moveDownItem($event,i)" [disabled]="i===this.articleData['article'].length-1">
            <mat-icon class="article-action-icon material-icons-outlined"
                      color="{{ i===this.articleData['article'].length-1 ? '' : 'accent'}}"
                      [matTooltip]="'Move down'">arrow_downward</mat-icon>
          </button>
          <button mat-icon-button class="article-action-btn" (click)="moveUpItem($event,i)" [disabled]="i===0">
            <mat-icon class="article-action-icon material-icons-outlined"
                      color="{{ i===0 ? '' : 'accent'}}"
                      [matTooltip]="'Move up'">arrow_upward</mat-icon>
          </button>
          <button mat-icon-button class="article-action-btn" (click)="deleteItem($event,i)">
            <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Delete'">delete</mat-icon>
          </button>
        </div>

        <h2 *ngIf="article['type']=='title'" [class.first-title]="i==titleIdx">
          {{article['value']}}
        </h2>

        <p *ngIf="article['type']=='text'" [innerHTML]="article['value'] | htmlHelper | TrustPipe"></p>

        <p *ngIf="article['type']=='image' && article['image_url']">
          <img src="{{article['image_url']}}">
          <button *ngIf="article['video_url']" mat-icon-button (click)="linkClick(article['video_url'])"
                  class="play-button">
            <mat-icon class="play-icon">play_circle</mat-icon>
          </button>
        </p>
        <h2 *ngIf="article['type']=='image' && article['caption']" class="image-caption">{{article['caption']}}</h2>

        <p *ngIf="article['type']=='cta' && article['image_url']">
          <img src="{{article['image_url']}}">
        </p>
        <h2 *ngIf="article['type']=='cta' && article['caption']" class="image-caption">{{article['caption']}}</h2>
        <p *ngIf="article['type']=='cta' && article['description']">
          {{article['description']}}
        </p>
        <button *ngIf="article['type']=='cta' && article['link']" class="widerButton font16"
                (click)="linkClick(article['link'])"
                mat-raised-button color="accent">
          {{article['link_text']}}
        </button>
      </div>
    </mat-card>
    <div class="right-content">
      <mat-card class="menu-container right-card" *ngIf="this.courseNavigation">
        <h2 class="membership">{{this.itemVsCourseData['folderName']}}</h2>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let category of this.courseNavigation; let i = index"
                               [expanded]="i === openedMenuItemIdx">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{category['group_name']}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p *ngFor="let articleItem of category['articles']; let j = index"
               [class.active-link]="listItem['itemFullData']['static_html_alias'] === articleItem['static_html_alias']">
              <a (click)="handleMenuClick(articleItem)">{{j+1}}. {{articleItem['title']}}</a>
            </p>
          </mat-expansion-panel>
          <!--<mat-expansion-panel>-->
            <!--<mat-expansion-panel-header>-->
              <!--<mat-panel-title>-->
                <!--Self aware panel-->
              <!--</mat-panel-title>-->
            <!--</mat-expansion-panel-header>-->
            <!--<p>I'm visible because I am open</p>-->
          <!--</mat-expansion-panel>-->
        </mat-accordion>
      </mat-card>
      <mat-card class="right-card">
        <h2 i18n>Created By</h2>
<!--        <img src="http://bufffit.com/filesstore/p561/g_WUf3w2fl_Dzphdf9k4m.png"/>-->
<!--        <img src="http://bufffit.com/filesstore/p1118/g_nx1J1kv2_r4qrco4jio.png?t=1618061357"/>-->
<!--        <h2 i18n class="name-wrapper">Anna Korneychuk</h2>-->
<!--        <h2 i18n class="membership">CHIEF TRAINER</h2>-->
        <img src="{{owner_picture}}"/>
        <h2 class="name-wrapper">{{owner_name}}</h2>
        <h2 class="membership" *ngIf="owner_role == 'owner'">{{'chief_administrator'|GetLabelPipe}}</h2>
        <h2 class="membership" *ngIf="owner_role == 'trainer'">{{company_team}}</h2>
      </mat-card>
    </div>
  </div>
</div>
